exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Navigate-module__wrapper___2JktG{display:grid;grid-template-columns:1fr 1fr;gap:.5em}.Navigate-module__wrapper___2JktG .Navigate-module__button___qZiTd{border-radius:4px;height:35px;width:35px;background-color:#bdccd4;color:#fff;display:flex;justify-content:center;align-items:center;font-size:20px;cursor:pointer;transition:.2s}.Navigate-module__wrapper___2JktG .Navigate-module__button___qZiTd.Navigate-module__can-finish___dXvZQ{background-color:#3edc89!important}.Navigate-module__wrapper___2JktG .Navigate-module__button___qZiTd.Navigate-module__blue___1oBET{background-color:#1368e5}", ""]);

// exports
exports.locals = {
	"wrapper": "Navigate-module__wrapper___2JktG",
	"button": "Navigate-module__button___qZiTd",
	"can-finish": "Navigate-module__can-finish___dXvZQ",
	"blue": "Navigate-module__blue___1oBET"
};